import CloseIcon from '@material-ui/icons/Close';
import {
    Box,
    Dialog,
    DialogContent,
    IconButton,
    Typography,
    useTheme
} from "@mui/material";
// import imagePlaceholder from '../../assets/img/image_placeholder.jpg';
import { useState } from "react";
import TS1 from '../../assets/img/TSCreation/TS1.png';
import TS2 from '../../assets/img/TSCreation/TS2.png';
import TS3 from '../../assets/img/TSCreation/TS3.png';


const steps = [
    {
        title: "Navigate to the Tests ",
        description: [
            "From the Dashboard, click on the Test Series tab.",
            "OR go to Manage Tests and select the Test Series option.",
        ],
        // image: product1,
    },
    {
        title: "Creating a New Test Series",
        description: [
            "Click on ‘+New’ button ",
        ],
        // image: product2,
    },
    {
        title: "In the Information tab, enter the required details ",
        description: [
            "Upload a custom image for the Test Series card.",
            "Provide the Course Code and Course Name.",
            "Select Objective and Target Audience, and add a Description.",
        ],
        image: TS1,
    },
    {
        title: "Test Tab ",
        description: [
            "Click the Add Tests button.",
            "Select your Subject/Sub-topic.",
            "Choose the desired test(s) and click Add Test.",
        ],
        image: TS2,
    },
    {
        title: "Configuration Tab",
        description: [
            "Set the difficulty level, status, and duration (expiry in days) for the Test Series.",
            "Click Save—the Test Series is now ready to be assigned to students.",
        ],
        image: TS3,
    },
];

function CourseCreationSteps() {
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const handleImageClick = (imgSrc) => {
        setSelectedImage(imgSrc);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedImage(null);
    };
    return (
        <Box maxWidth="md" mx="auto" p={4}>
            <Typography variant="h5" gutterBottom>
                Test Series (A Test Series consists of multiple individual tests.)
            </Typography>

            {steps.map((step, index) => (
                <Box
                    key={index}
                    display="flex"
                    flexDirection={index % 2 === 0 ? "row" : "row-reverse"}
                    alignItems="center"
                    my={5}
                    gap={4}
                    flexWrap="wrap"
                >
                    <Box
                        component="img"
                        src={step?.image}
                        alt={`Step ${index + 1}`}
                        onClick={() => handleImageClick(step.image)}
                        sx={{
                            width: { xs: "100%", sm: "25%" },
                            borderRadius: 2,
                            boxShadow: 3,
                            visibility: step.image ? 'visible' : 'hidden',
                            cursor: "pointer",
                            transition: "transform 0.2s",
                            "&:hover": {
                                transform: "scale(1.05)",
                            },
                        }}
                    />
                    <Box flex="1" minWidth="250px">
                        {step?.mainTitle && <Typography variant="h6" sx={{ color: '#e63573', textTransform: 'none' }}>{step.mainTitle}</Typography>}
                        <Typography variant="body1" sx={{ textTransform: 'none', fontWeight: 'bold' }}>{step.title}</Typography>
                        <ul>
                            {step.description.map((item, idx) => (
                                <li key={idx}>
                                    <Typography variant="body1">{item}</Typography>
                                </li>
                            ))}
                        </ul>
                    </Box>
                </Box>
            ))}
            {/* Dialog for Image Popup */}
            <Dialog open={open} onClose={handleClose} maxWidth="md">
                <IconButton
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        zIndex: 1,
                        color: "grey.500",
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    {selectedImage && (
                        <Box
                            component="img"
                            src={selectedImage}
                            alt="Popup Preview"
                            sx={{
                                width: "100%",
                                height: "auto",
                                borderRadius: 2,
                                boxShadow: 3,
                            }}
                        />
                    )}
                </DialogContent>
            </Dialog>
        </Box>
    );
}


export default CourseCreationSteps